import React, { useEffect, useRef } from 'react';
import { useWindowDimensions } from '../../../../common/utils/windowDimensions';
import defaultCss from './SingleNews.module.scss';
// import classnames from 'classnames';
import { svgSprite } from '../../../../hybrid/wrappers';
import parse from 'html-react-parser';
import { navigateV2 } from '../../../../common/utils/router';
import NewsImage from '../../../../widgets/newsImage/NewsImage';

function SingleNews({ news = {}, maxSizeTitle, setMaxSizeTitleArray, index, componentCss }) {
    const css = componentCss || defaultCss;
    // const [activeCategories, setActiveCategories] = useState(news.categories.filter((el) => el.status === 'active'));
    // useEffect(() => {
    //     setActiveCategories(news.categories.filter((el) => el.status === 'active'));
    // }, [news]);
    const widthDimensions = useWindowDimensions();
    const titleHeight = useRef(null);
    useEffect(() => {
        if (maxSizeTitle !== null && setMaxSizeTitleArray) {
            if (titleHeight?.current?.clientHeight) {
                setMaxSizeTitleArray((pre) =>
                    pre.map((el, i) => {
                        if (i === index) {
                            return titleHeight.current.clientHeight;
                        }
                        return el;
                    })
                );
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [widthDimensions]);

    return (
        <>
            <div onClick={() => navigateV2(`/news/${news.seo_url}`)} className={css.newsComponent}>
                <div className={css.newsImage}>
                    <NewsImage item={news} />
                </div>
                <div className={css.newsContent}>
                    <p className={css.newsTitle}>{news.title}</p>
                    <p className={css.newsInfo}>{parse((news.text || '')?.slice(0, 500) + '...')}</p>
                    <div className={css.newsBottom}>
                        <div className={css.newsDateWrapper}>
                            <div className={css.newsDateIcon}>{svgSprite('calendar-news')}</div>
                            <p className={css.newsDate}>{news.created_at}</p>
                        </div>
                        <div className={css.newsLine}></div>
                        <div className={css.newsCategories}>
                            {news.categories.map((cat) => (
                                <div
                                    onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        navigateV2(`/news/category/${cat.seo_url}`);
                                    }}
                                    className={css.newsCategory}
                                    key={cat.id}
                                >
                                    <div className={css.newsCategoryCircle}></div>
                                    <p className={css.newsCategoryName}>{cat.title}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SingleNews;
